import styled from "styled-components";

const Wrapper = styled.div`
`;


const Styled = { Wrapper }
export default Styled;
